var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.getModals),function(modal){return _c('modal',{key:modal.modal_id,staticClass:"custom_modal",attrs:{"payload":modal}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }